export function getBit(value: number, bitPosition: number): number {
    return (value & (1 << bitPosition)) == 0 ? 0 : 1;
}

export function setBit(value: number, bitPosition: number): number {
    return value | (1 << bitPosition);
}

export function clearBit(value: number, bitPosition: number): number {
    return value & ~(1 << bitPosition);
}

export function flipBit(value: number, bitPosition: number): number {
    return getBit(value, bitPosition) == 0 ? setBit(value, bitPosition) : clearBit(value, bitPosition);
}